import React, { useState } from "react"
import styled from "@emotion/styled"

import ModalWildImageDesk from "../../../master/modalwildimage/modalwildimagedesk"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import Video from "../../video"
import ExpandIcon from "../../../../../assets/icons/wild/expand-icon.svg"

import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { classNames } from "../../../../../utils/general"

const ImageAreaWrap = styled.div`
  clear: both;
  background: ${theme.wild.color.men.base.primary};
  padding: 36px 0 0 0;
  max-width: 1210px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  ${queries.medium`
    padding: 97px 0 0 0 ;
    flex-wrap: wrap;
    .tile-item {
      width: 50%;
    }
  `}
  ${queries.large`
    padding: 66px 0 0;
  `}
  .tile-item {
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 4px;
      img {
        width: 100%;
      }
    }
  }
  img {
    width: 100%;
    border-radius: 4px;
  }
`
const TileItem = styled.div`
  position: relative;
  margin: 0 15px 8px;
  video {
    height: 100%;
    border-radius: 4px;
  }
  .subtitle {
    font-size: 32px !important;
  }
  &.with-modal {
    position: relative;
    .expand-wrap {
      display: none;
    }
  }
  ${queries.small`
    width: 50%;
    margin: 0 0 8px;
    padding: 0 4px;
     .subtitle {
       font-size: 28px !important;
    }
  `}
  ${queries.medium`
    video {
      border-radius: 4px;
    }
    .subtitle {
      font-size: 20px !important;
    }
    cursor: pointer;
    width: 100%;
    &.with-modal {
      position: relative;
      .expand-wrap {
        position: absolute;
        opacity: 0;
        visibility: hidden;
        top: 0;
        left: 4px;
        height: 100%;
        width: calc(100% - 8px);
        background: rgba(0, 87, 82, .2);
        transition: all ease-in-out .15s;
        border-radius: 4px;
        svg {
          height: 120px;
          width: 120px;
          position: absolute;
          top: calc(50% + 10px);
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      &:hover {
        .expand-wrap {
          display: block;
          visibility: visible;
          opacity: 1;
        }
      }
    }
  `}
    ${queries.large`
    .subtitle {
       font-size: 28px !important;  
       `}
  img {
    border-radius: 4px;
  }
`

const ImageArea = ({ data }) => {
  const [activeImageIndex, setActiveImageIndex] = useState(null)
  const _data = [...data]

  const ModalImage = (item) => {
    return (
      <>
        {item.video ? (
          <Video {...item} />
        ) : (
          <img src={item.image} alt={item?.alt || item.name} />
        )}
      </>
    )
  }

  const carouselItemClick = (item, i) => {
    const width = window.innerWidth
    if (width >= 768) {
      segmentEvent("Image Gallery Clicked", {
        image_url: item.image,
        module_location: "mid_fold",
        slide_number: i + 1,
      })
      setActiveImageIndex(i)
    }
  }

  const renderImageItems = _data.map((item, i) => {
    return (
      <React.Fragment key={`item-image-${i}`}>
        {item.video ? (
          <TileItem className="tile-item">
            <Video {...item} id={`video-tile-desktop`} className="tile-item" />
          </TileItem>
        ) : (
          <TileItem
            onClick={() => carouselItemClick(item, i)}
            onKeyDown={(e) =>
              e.key === "Enter" ? carouselItemClick(item, i) : null
            }
            className={`tile-item with-modal ${item.name || ""}`}
            role="button"
            aria-label={
              item.name
                ? "Click to expand " + item.name + " image"
                : "Click to expand image"
            }
            tabIndex="0"
          >
            <img
              src={item.image}
              alt={item?.alt || item.name}
              className={classNames({
                "show-md-up": item.mobileImage,
              })}
            />
            {item.mobileImage ? (
              <img
                src={item.mobileImage}
                alt={item?.alt || item.name}
                className="hide-md-up"
              />
            ) : null}
            <div className="expand-wrap">
              <ExpandIcon />
            </div>
          </TileItem>
        )}
      </React.Fragment>
    )
  })

  const renderModalItems = _data.map((item, i) => (
    <React.Fragment key={`item-modal-${i}`}>
      {activeImageIndex === i && (
        <ModalWildImageDesk
          desktopOnly={true}
          component={ModalImage}
          propsObject={item}
          hideModal={() => setActiveImageIndex(null)}
        />
      )}
    </React.Fragment>
  ))

  return (
    <ImageAreaWrap className={`imageareawrap`}>
      {renderImageItems}
      {renderModalItems}
    </ImageAreaWrap>
  )
}

export default ImageArea
